import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MOBILE_APP } from '../constants/mobileApp';
import { trackClickContact } from '../analytics';

export default function PublicChatWidget() {
  const [open, setOpen] = useState(false);

  return (
    <div className={`pp-chat-widget${open ? ' is-open' : ''}`}>
      {open ? (
        <div className="pp-chat-panel" role="dialog" aria-label="Contact assistant">
          <div className="pp-chat-panel-head">
            <strong>Next Follow UP</strong>
            <button type="button" className="pp-chat-close" onClick={() => setOpen(false)} aria-label="Close chat">
              <i className="fas fa-times" aria-hidden="true" />
            </button>
          </div>
          <p className="pp-chat-panel-desc">
            Questions about pricing, Meta Lead Ads, or onboarding? We are happy to help.
          </p>
          <div className="pp-chat-panel-actions">
            <Link
              to="/contact-sales"
              className="pp-btn pp-btn-primary pp-chat-action"
              onClick={() => {
                trackClickContact({ location: 'chat_widget' });
                setOpen(false);
              }}
            >
              Contact sales
            </Link>
            <a href={`mailto:${MOBILE_APP.supportEmail}`} className="pp-btn pp-btn-ghost pp-chat-action">
              Email us
            </a>
          </div>
        </div>
      ) : null}
      <button
        type="button"
        className="pp-chat-fab"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        aria-label={open ? 'Close enquiry chat' : 'Open enquiry chat'}
      >
        <i className={`fas ${open ? 'fa-times' : 'fa-comment-dots'}`} aria-hidden="true" />
      </button>
    </div>
  );
}
